import { IHttpError } from 'shared/interfaces/IHttpError';

export default class HttpError implements IHttpError {
  public status: number;
  public message: string;
  constructor(status: number, message: string) {
    this.status = status;
    this.message = message;
  }
}
